import environment from "../../../../environments/environment";
import { axiosInterceptor } from "../authInterceptor";


export async function getAutoDebitListDetails(Vivo: any) {
    try {
      const getAutoDebitResponse = await axiosInterceptor.post(`${environment.postAutoDebitsList}`, Vivo);
      return getAutoDebitResponse;
    } catch (error: any) {
      return error;
    }
  }

  export async function getLoanNumberByPId(participantId: number, clientId: number) {
    try {
      const resLoanSummaryByPId = await axiosInterceptor.get(`${environment.loanDetailsByPID}/${participantId}?clientId=${clientId}`);
      return resLoanSummaryByPId;
    } catch (error: any) {
      return error;
    }
  } 

  export async function getLoanDatesByLoanId(loanId: number, clientId: number) {
    try {
      const resLoanDatesByLoanId = await axiosInterceptor.get(`${environment.loanDatesByLoanId}/${loanId}/payment/dates?clientId=${clientId}`);
      return resLoanDatesByLoanId;
    } catch (error: any) {
      return error;
    }
  } 

  export async function getSourceList(participantId: number, clientId: number) {
    try {
      const resLoanDatesByLoanId = await axiosInterceptor.get(`${environment.loanSourceByPID}/${participantId}?clientId=${clientId}`);
      return resLoanDatesByLoanId;
    } catch (error: any) {
      return error;
    }
  }

  export async function saveAutoDebitDetails(Vivo: any) {
    try {
      const getAutoDebitResponse = await axiosInterceptor.post(`${environment.saveAutoDebit}`, Vivo);
      return getAutoDebitResponse;
    } catch (error: any) {
      return error;
    }
  }

  export async function getAutoDebitDetailsById(Id: number, clientId: number) {
    try {
      const resLoanDatesByLoanId = await axiosInterceptor.get(`${environment.saveAutoDebit}${Id}?clientId=${clientId}`);
      return resLoanDatesByLoanId;
    } catch (error: any) {
      return error;
    }
  }

  export async function deleteAutoDebitDetailsById(Id: number, clientId: number) {
    try {
      const response = await axiosInterceptor.delete(`${environment.deleteAutoDebit}${Id}?clientId=${clientId}`);
      return response;
    } catch (error: any) {
      return error;
    }
  }


//   function getAutoDebitTestRes() {
//     const testData =  {
//         data: {
//             message: "Successfully fetched the auto debit loan details",
//             data: [
//                 {
//                     "autoDebitId": 10,
//                     "loanId": 14,
//                     "loanNumber": "vk-31012025-1",
//                     "loanDescription": "Testing the Loan",
//                     "payment": "Statement Due",
//                     "loanDueDate": "2025-05-01T00:00:00",
//                     "autoDebitDate": "2025-03-01T08:00:00",
//                     "frequency": "3 days before due date",
//                     "status": "Active"
//                 },
//                 {
//                     "autoDebitId": 9,
//                     "loanId": 19,
//                     "loanNumber": "vk-12032025-3",
//                     "loanDescription": "Testing the Loan",
//                     "payment": "Statement Due",
//                     "loanDueDate": "2025-05-01T00:00:00",
//                     "autoDebitDate": "2025-04-28T00:00:00",
//                     "frequency": "3 days before due date",
//                     "status": "Active"
//                 },
//                 {
//                     "autoDebitId": 8,
//                     "loanId": 18,
//                     "loanNumber": "vk-12032025-2",
//                     "loanDescription": "Testing the Loan",
//                     "payment": "Statement Due",
//                     "loanDueDate": "2025-05-01T00:00:00",
//                     "autoDebitDate": "2025-04-28T00:00:00",
//                     "frequency": "3 days before due date",
//                     "status": "Active"
//                 }
//             ],
//             totalRecordCount: 4
//         },
//         status: 200,
//     }
//     return testData
// }
 

 